import { useMenuData } from "../offline/menuData"
import "./SyncError.css"

// The menu couldn't be downloaded or read and there is no copy to show: the message and a retry.
export default function SyncError({ message }) {
  const { isOnline, syncNow } = useMenuData()

  return (
    <div className="sync-error" role="alert">
      <p className="sync-error__message t-y24">{message}</p>
      <button type="button" className="sync-error__retry" disabled={!isOnline} onClick={syncNow}>
        Try again
      </button>
    </div>
  )
}
